import { type MetaFunction } from '@remix-run/node'
import { AppHeader } from '#app/components/ui/app-header.tsx'
import { ActivityHero } from './_activity-hero.tsx'

export const meta: MetaFunction = () => {
	return [
		{
			title: 'Red Pepper Pizza | EB100 GmbH',
		},
	]
}

export default function RedPepperPizza() {
	return (
		<div>
			<AppHeader />

			<ActivityHero
				title="Bringing the best pizza to communities"
				blendImageSrc="/img/rpp.webp"
				blendImageAlt="Square pizza and pizza ingredients on a table"
				figure={
					<>
						<p>Red Pepper Pizza</p>
						<p>Slice of Perfection</p>
					</>
				}
				content={
					<>
						<p className="mt-6">
							Faucibus commodo massa rhoncus, volutpat. Dignissim sed eget risus
							enim. Mattis mauris semper sed amet vitae sed turpis id. Id dolor
							praesent donec est. Odio penatibus risus viverra tellus varius sit
							neque erat velit. Faucibus commodo massa rhoncus, volutpat.
							Dignissim sed eget risus enim. Mattis mauris semper sed amet vitae
							sed turpis id.
						</p>
						<p className="mt-8">
							Et vitae blandit facilisi magna lacus commodo. Vitae sapien duis
							odio id et. Id blandit molestie auctor fermentum dignissim. Lacus
							diam tincidunt ac cursus in vel. Mauris varius vulputate et
							ultrices hac adipiscing egestas. Iaculis convallis ac tempor et
							ut. Ac lorem vel integer orci.
						</p>
						<p className="mt-8">
							Et vitae blandit facilisi magna lacus commodo. Vitae sapien duis
							odio id et. Id blandit molestie auctor fermentum dignissim. Lacus
							diam tincidunt ac cursus in vel. Mauris varius vulputate et
							ultrices hac adipiscing egestas. Iaculis convallis ac tempor et
							ut. Ac lorem vel integer orci.
						</p>
					</>
				}
			/>
		</div>
	)
}
